module.exports = __webpack_public_path__ + "static/media/soundcloud.e01b8b61.svg";